import { render, staticRenderFns } from "./OrderMailReceiverRegist.vue?vue&type=template&id=31b80248&scoped=true&"
import script from "./OrderMailReceiverRegist.vue?vue&type=script&lang=js&"
export * from "./OrderMailReceiverRegist.vue?vue&type=script&lang=js&"
import style0 from "./OrderMailReceiverRegist.vue?vue&type=style&index=0&id=31b80248&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b80248",
  null
  
)

export default component.exports